(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CFP-Main-Content-Section"] && !Shopify.designMode) return;
  try {
    


 var productsUrl = '{{collection.url }}/products.json';
  var productIndex = [];
  var colorFilter = false;
  var colors = [];
  $(document).ready(function() {   
 
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".loadFirst").css("display", "block");
    
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".overstock-collection").css("display", "block");
    //hides cateory section if there are no products associated in that category.
   $('.overstock-group p').each(function (){
     if($(this).hasClass('no-product')){
       $(this).parent('.overstock-group').hide();
     }
   })
    // hides the info icon hover popup before the page is loaded
    //$(".hover-container.hover-popup").removeClass("hidden");
    $(".hover-popup").css("display", "block");

    // change the vinyl product variant id & values when color swatch is clicked
    $('.cfp-variantion-color-box-parent > div').click(function(e) { 
        var new_selected_variant_id = $(this).attr('id').replace('select-', '');    
        var old_variant_id = $(this).data('first');
        var new_price_selected = $(this).data('price'); 
        // sets all the color boxes to deselected
        $('.color-box').css("border","1px solid #1C355E");         
        // sets the selected color box to selected
        $('#select-' + new_selected_variant_id).css("border","2px solid #AA2D29");  
        // changes the value of the id on the submit form for add-to-cart
        $('#' + old_variant_id).val(new_selected_variant_id);  
        // changes price to the correct color price 
        $('#price-' + old_variant_id).html(new_price_selected);  
        // changes the variant of the details button to send correct color to details page
        $('#variant-' + old_variant_id).data('variant', new_selected_variant_id);      
    });

    // the details form button directs to the product page!
    $('.details-cfp-btn').click(function() {
     var collection_url_base = $(this).data('collection');
     var product_url_base = $(this).data('product');
     var product_variation_string = $(this).data('variant');
     setTimeout(function() {
     window.location = '/collections/' + collection_url_base + '/products/' + product_url_base + '?variant=' + product_variation_string }, 10);     
    }); 

    // the submit form updates the cart, this passes the form to the cart!
    $('.buy-cfp-btn').click(function() {
     setTimeout(function() {
     window.location = '/cart'}, 600);
    });
    

  var items = [];
  function add(item) {
    Shopify.addItem(item.id, item.quantity, function(e) {
      if (items.length > 0) {
        add(items.shift());
      } else {
        window.location = '/cart';
      }
    });
  }

  function addToCart(element) {
    $('[data-variant-id]:visible').each(function() {
      if ($('input.quantity', $(this)).val() > 0) {
        items.push({ id: $(this).data('variant-id'), quantity: parseInt($('input.quantity', $(this)).val())});
      }
    });
    if (items.length > 0) {
      $(element).html('Redirecting to Cart').attr('disabled', 'disabled');
      add(items.shift());
    } else {
      window.location = '/cart';
    }
  }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function() {    
   $('.media > img').each(function() {
    if ( $(this).attr('src') == '//americanvinylworks.com/cdn/shop/files/drawmyfence.png?v=1691006068&width=3200' ) {
      $(this).parent().wrap('<a href="/pages/draw-my-fence"></a>');
    };
   });
 });   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-fence-packages"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function() {   

    $(".loadFirst").css("display", "block");
    $(".overstock-collection").css("display", "block");

    // hides category section if there are no products associated in that category.
    $('.overstock-group p').each(function (){
      if($(this).hasClass('no-product')){
        $(this).parent('.overstock-group').hide();
      }
    });

    $(".hover-popup").css("display", "block");

    // highlight the default selected color on each card
    $('.color-box[data-selected="true"]').css("border", "2px solid #AA2D29");

    // color swatch clicked: update that card's variant, price, buy form and links
    $(document).on('click', '.cfp-variantion-color-box-parent > .color-box', function() {
      var $box = $(this);
      if ($box.attr('data-soldout')) { return; }
      var $card = $box.closest('.complete-fence-package-card');
      var variantId = $box.data('variant');

      // deselect all swatches on this card, select the clicked one
      $card.find('.color-box').css("border", "1px solid #1C355E");
      $box.css("border", "2px solid #AA2D29");

      // BUY NOW form gets the selected variant (color + package length)
      $card.find('.cfp-variant-input').val(variantId);
      // price for the selected color
      $card.find('.complete-fence-package-price').html($box.data('price'));
      // CUSTOMIZE button + image/title links open the product on the selected variant
      $card.find('.details-cfp-btn').data('variant', variantId);
      $card.find('a[data-variant-link]').each(function() {
        this.href = this.getAttribute('data-base-url') + '?variant=' + variantId;
      });
    });

    // the details button directs to the product page with the selected variant
    $('.details-cfp-btn').click(function() {
      var collection_url_base = $(this).data('collection');
      var product_url_base = $(this).data('product');
      var product_variation_string = $(this).data('variant');
      setTimeout(function() {
        window.location = '/collections/' + collection_url_base + '/products/' + product_url_base + '?variant=' + product_variation_string;
      }, 10);     
    }); 

    // the submit form updates the cart, then goes to the cart
    $('.buy-cfp-btn').click(function() {
      setTimeout(function() {
        window.location = '/cart';
      }, 600);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-center-selector"] && !Shopify.designMode) return;
  try {
    

    $(document).ready(function() {

    $(".quote-center-padding").parent().css({"border-bottom": "1px solid black", "border-top": "1px solid black"});
      
    // var url      = window.location.href; 
    // if (url == "https://americanvinylworks.com/") {
    //     console.log("home page");
    //     $(".quote-center-padding").attr("style", "display:block;");
    //     $(".quote-center-padding").data("display", "show");
    //     $("#Details-HeaderMenu-1").prop('open', 'true');
    // };    
    
    // // show and hides quote center on click
    // $("#HeaderMenu-quote-center").on("click", function() {
    //   if ($(".quote-center-padding").data("display") == "hide") { 
    //     $(".quote-center-padding").attr("style", "display:block;");
    //     $(".quote-center-padding").data("display", "show");
    //     // $("#Details-HeaderMenu-1").prop('open', 'true');
    //     //console.log('from hide to show');
    //   } 
    //   else 
    //   {  
    //     $(".quote-center-padding").attr("style", "display:none;");
    //     $(".quote-center-padding").data("display", "hide");
    //     // $("#Details-HeaderMenu-1").prop('open', 'false');
    //     //console.log('from show to hide');
    //     return;
    //   };
    // }); 

    // // keeps quote center carrot in correct position if open
    // $(".header__menu-item").on("click", function() {
    //   if ($(this).parent().attr('id') != "Details-HeaderMenu-1") {
    //     //console.log('not quote center');
    //     if ($(".quote-center-padding").data("display",) == "show") {
    //       $("#Details-HeaderMenu-1").prop('open', 'true');
    //     };
    //   };
    // });  
    
  });


  } catch(e) { console.error(e); }
})();
})();
